module.exports = __webpack_public_path__ + "img/pisx_QR.d6538421.jpg";